import styled from "styled-components"

const PersonalBlogWrapper = styled.div` 
padding: 0 1.5rem;
@media (min-width: 768px) {
    width: 100%;
    padding: 0 2rem;
}
@media (min-width: 990px) {
  width: 100%;
  padding: 0 8rem;
}
@media (min-width: 1550px) {
    padding: 0 -webkit-calc(40% - 37.5rem);
    padding: 0 calc(40% - 37.5rem);
}
`

export default PersonalBlogWrapper
